import script from "./EmptyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyTable.vue?vue&type=script&setup=true&lang=js"

import "./EmptyTable.vue?vue&type=style&index=0&id=25cd0ad4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cd0ad4"]])

export default __exports__